/**
 * @generated SignedSource<<272e4d5eca1d914750619883cb072e72>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CorporateActionType = "DELISTING" | "DIVIDEND" | "MERGER_CASH" | "MERGER_CASH_STOCK" | "MERGER_STOCK" | "REVERSE_STOCK_SPLIT" | "RIGHTS_ISSUE" | "SPIN_OFF" | "STOCK_SPLIT" | "TENDER";
export type CryptoActionTransactionDirection = "INCOMING" | "OUTGOING";
export type CryptoActionType = "MERGER_CRYPTO";
export type CryptoTransfersTransactionRequiredActions = "BENEFICIARY_DETAILS";
export type CryptoTransfersTransactionStatus = "CANCELED" | "FINISHED" | "NOT_CONFIRMED" | "ON_HOLD" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type CryptoTransfersTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type FiatDepositTradeOutcome = "TRADE_COMPLETED" | "TRADE_PENDING";
export type FiatTransactionType = "DEPOSIT" | "WITHDRAWAL";
export type FiatTransferNotificationOutcome = "FAILURE" | "SUCCESS";
export type NonUserInitiatedTransactionDirection = "INCOMING" | "OUTGOING";
export type NonUserInitiatedTransactionType = "GIVEAWAY" | "METAL_STORAGE_FEE" | "OTC_TRADE" | "STAKING_REWARD" | "TAX_REFUND";
export type NotificationType = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NEW_LEGAL_DOCUMENTS" | "NON_USER_INITIATED_TRANSACTION" | "ORDER" | "REPORT" | "SAVINGS_PLAN";
export type OrderFailReason = "CANCELLED_BY_USER" | "CANCELLED_DUE_TO_ASSET_DISABLING" | "EXPIRED" | "ORDER_EXECUTION_ERROR" | "SLIPPAGE_EVALUATION" | "USER_ACCOUNT_INACTIVE" | "USER_TRANSACTION_INACTIVE_CRYPTOCOIN" | "USER_TRANSACTION_OPERATIONS_DISABLED" | "USER_TRANSACTION_TRADING_DISABLED";
export type OrderNotificationStatus = "CANCELED" | "EXPIRED" | "FAILED" | "FINISHED";
export type OrderNotificationType = "BUY" | "SELL";
export type ReportType = "ACCOUNT_STATEMENT" | "CRYPTO_TAX" | "SECURITIES_ACCOUNT_CLOSED" | "TRADES_VALUE_ADDED_TAX" | "XPCT";
export type SavingsPlanNotificationStatus = "CANCELED" | "FAILED" | "FINISHED";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type NotificationsInput = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  type?: NotificationType | null | undefined;
};
export type NotificationsViewQuery$variables = {
  input?: NotificationsInput | null | undefined;
};
export type NotificationsViewQuery$data = {
  readonly notificationsV3: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly asset: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly assetAmount: PrecisionFloat | null | undefined;
        readonly content: {
          readonly __typename: "CorporateActionNotificationV3Content";
          readonly corporateActionId: string;
          readonly corporateActionType: CorporateActionType;
        } | {
          readonly __typename: "CryptoActionNotificationV3Content";
          readonly creditedAt: TimeScalar;
          readonly cryptoActionId: string;
          readonly cryptoActionType: CryptoActionType;
          readonly transactions: ReadonlyArray<{
            readonly asset: {
              readonly id: string;
              readonly name: string | null | undefined;
              readonly symbol: string | null | undefined;
            };
            readonly assetAmount: PrecisionFloat | null | undefined;
            readonly direction: CryptoActionTransactionDirection;
            readonly feeAmount: PrecisionFloat | null | undefined;
            readonly fiat: {
              readonly id: string;
              readonly name: string | null | undefined;
              readonly symbol: string | null | undefined;
            } | null | undefined;
            readonly fiatAmount: PrecisionFloat | null | undefined;
            readonly id: string;
          }> | null | undefined;
        } | {
          readonly __typename: "CryptoTransferNotificationV3Content";
          readonly cryptoTransferType: CryptoTransfersTransactionType;
          readonly requiredAction: CryptoTransfersTransactionRequiredActions | null | undefined;
          readonly status: CryptoTransfersTransactionStatus;
          readonly transferId: string;
        } | {
          readonly __typename: "FiatTransferNotificationV3Content";
          readonly depositTradeOutcome: FiatDepositTradeOutcome | null | undefined;
          readonly fiatTransferType: FiatTransactionType;
          readonly offerId: string | null | undefined;
          readonly outcome: FiatTransferNotificationOutcome;
          readonly transferId: string;
        } | {
          readonly __typename: "NonUserInitiatedTransactionNotificationV3Content";
          readonly direction: NonUserInitiatedTransactionDirection;
          readonly nuitType: NonUserInitiatedTransactionType;
          readonly transactionId: string;
        } | {
          readonly __typename: "OrderNotificationV3Content";
          readonly domainSlug: string | null | undefined;
          readonly externalOrderId: string | null | undefined;
          readonly failReason: OrderFailReason | null | undefined;
          readonly orderId: string;
          readonly orderStatus: OrderNotificationStatus;
          readonly orderType: OrderNotificationType;
          readonly tradeId: string | null | undefined;
        } | {
          readonly __typename: "ReportNotificationV3Content";
          readonly reportId: string;
          readonly reportType: ReportType;
        } | {
          readonly __typename: "SavingsPlanNotificationV3Content";
          readonly cancelReason: string | null | undefined;
          readonly externalTransactionId: string | null | undefined;
          readonly externalTransactionStatus: TransactionStatus | null | undefined;
          readonly savingsPlanId: string;
          readonly savingsPlanName: string;
          readonly savingsPlanStatus: SavingsPlanNotificationStatus;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly createdAt: TimeScalar;
        readonly fiat: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly symbol: string | null | undefined;
        } | null | undefined;
        readonly fiatAmount: PrecisionFloat | null | undefined;
        readonly id: string;
        readonly notificationType: NotificationType;
        readonly readAt: TimeScalar | null | undefined;
        readonly translationKey: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly startCursor: string | null | undefined;
    } | null | undefined;
    readonly totalCount: number | null | undefined;
    readonly unreadCount: number | null | undefined;
  } | null | undefined;
};
export type NotificationsViewQuery = {
  response: NotificationsViewQuery$data;
  variables: NotificationsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translationKey",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v13 = [
  (v6/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Fiat",
  "kind": "LinkedField",
  "name": "fiat",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reportType",
      "storageKey": null
    }
  ],
  "type": "ReportNotificationV3Content",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cryptoTransferType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requiredAction",
      "storageKey": null
    }
  ],
  "type": "CryptoTransferNotificationV3Content",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "corporateActionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "corporateActionType",
      "storageKey": null
    }
  ],
  "type": "CorporateActionNotificationV3Content",
  "abstractKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nuitType",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "type": "NonUserInitiatedTransactionNotificationV3Content",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "savingsPlanId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "savingsPlanName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "savingsPlanStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalTransactionId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalTransactionStatus",
      "storageKey": null
    }
  ],
  "type": "SavingsPlanNotificationV3Content",
  "abstractKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cryptoActionId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cryptoActionType",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeAmount",
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domainSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalOrderId",
      "storageKey": null
    }
  ],
  "type": "OrderNotificationV3Content",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fiatTransferType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outcome",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "depositTradeOutcome",
      "storageKey": null
    }
  ],
  "type": "FiatTransferNotificationV3Content",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationV3Connection",
        "kind": "LinkedField",
        "name": "notificationsV3",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationV3Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationV3",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CryptoActionNotificationV3Transaction",
                            "kind": "LinkedField",
                            "name": "transactions",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CryptoActionNotificationV3Content",
                        "abstractKey": null
                      },
                      (v29/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NotificationV3Connection",
        "kind": "LinkedField",
        "name": "notificationsV3",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationV3Edge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NotificationV3",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "asset",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v6/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CryptoActionNotificationV3Transaction",
                            "kind": "LinkedField",
                            "name": "transactions",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v22/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/),
                                  (v6/*: any*/),
                                  (v12/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v28/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CryptoActionNotificationV3Content",
                        "abstractKey": null
                      },
                      (v29/*: any*/),
                      (v30/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ef93b04681eb8ee181dc7adbfdbb821",
    "id": null,
    "metadata": {},
    "name": "NotificationsViewQuery",
    "operationKind": "query",
    "text": "query NotificationsViewQuery(\n  $input: NotificationsInput\n) {\n  notificationsV3(input: $input) {\n    totalCount\n    unreadCount\n    pageInfo {\n      startCursor\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        translationKey\n        notificationType\n        createdAt\n        readAt\n        asset {\n          __typename\n          id\n          name\n          symbol\n        }\n        assetAmount\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        content {\n          __typename\n          ... on ReportNotificationV3Content {\n            reportId\n            reportType\n          }\n          ... on CryptoTransferNotificationV3Content {\n            transferId\n            cryptoTransferType\n            status\n            requiredAction\n          }\n          ... on CorporateActionNotificationV3Content {\n            corporateActionId\n            corporateActionType\n          }\n          ... on NonUserInitiatedTransactionNotificationV3Content {\n            transactionId\n            nuitType\n            direction\n          }\n          ... on SavingsPlanNotificationV3Content {\n            savingsPlanId\n            savingsPlanName\n            savingsPlanStatus\n            cancelReason\n            externalTransactionId\n            externalTransactionStatus\n          }\n          ... on CryptoActionNotificationV3Content {\n            cryptoActionId\n            cryptoActionType\n            creditedAt\n            transactions {\n              id\n              direction\n              asset {\n                __typename\n                id\n                symbol\n                name\n              }\n              assetAmount\n              fiat {\n                id\n                name\n                symbol\n              }\n              fiatAmount\n              feeAmount\n            }\n          }\n          ... on OrderNotificationV3Content {\n            orderId\n            tradeId\n            domainSlug\n            orderType\n            orderStatus\n            failReason\n            externalOrderId\n          }\n          ... on FiatTransferNotificationV3Content {\n            transferId\n            offerId\n            fiatTransferType\n            outcome\n            depositTradeOutcome\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7ea0df81d4cad554fed2003ffb0c450";

export default node;
